import type { CustomErrorRule } from '@/core/error/transport/types'
import { TmApiDealsDealNotFoundError } from '@/core/error/transport/tmApiDealsDealNotFoundError'

export const dealsDealNotFoundErrorRule: CustomErrorRule = {
  klass: TmApiDealsDealNotFoundError,
  predicateFn: (error) => {
    return error.response.data.message.includes('Deal object not found')
  },
}
